<template>
  <div class="w-full">
    <div class="flex flex-wrap mb-12">
      <div
        class="rounded min-h-0  w-1 mr-4 items-center"
        :class="{'bg-red-500': advice.score === -2, 'bg-yellow-500': advice.score === -1, 'bg-gray-500': advice.score === 0, 'bg-blue-500': advice.score === 1, 'bg-green-500': advice.score === 2}"
      ></div>

      <div class="flex-1 items-center">{{ advice.message[lang] }}</div>

      <div class="ml-8 cursor-pointer items-center">
        <k-dropdown>
          <template slot="handler">
            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
          </template>
          <k-dropdown-option @click.native="edit">Edit</k-dropdown-option>
          <k-dropdown-option @click.native="remove">Remove</k-dropdown-option>
        </k-dropdown>
      </div>
    </div>

    <advice-form v-if="openEdition" :id="id" :open="openEdition" @close="close"></advice-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import adviceForm from '@/components/advice/advice-form.vue'

export default {
  name: 'advice',

  components: { adviceForm },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      openEdition: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('advices', {
      getById: 'getById'
    }),

    advice () {
      return this.getById(this.id)
    }
  },

  methods: {
    ...mapActions('advices', ['removeAdvice']),

    edit () {
      this.openEdition = true
    },

    remove () {
      console.log('remove this :' + this.id)
      this.removeAdvice({advice: this.advice}).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.advice.deleted'), type: 'success'})
      }).catch(() => {
        this.$notify.error({title: 'Success', message: this.$root.$t('notifications.unknown')})
      })
    },

    close () {
      this.openEdition = false
    }
  }
}
</script>

<style lang="scss" scoped>
        span.color {
            height: 100%;
            width: 4px;
            margin-left: 6px;
            border-radius: 2px;
            display: block;

            &.red {
                background-color: #C0392B;
            }

            &.yellow {
                background-color: #EB9532;
            }

            &.grey {
                background-color: #6C7A89;
            }

            &.blue {
                background-color: #3498DB;
            }

            &.green {
                background-color: #1BBC9B;
            }
        }
</style>



// WEBPACK FOOTER //
// src/components/advice/advice.vue